const AnalystData = [
  ['86Research Limited', 'Xiaoyan Wang', 'xiaoyan@86research.com'],
  ['AJ Securities Limited', 'Shiming Liang', 'Shimingliang@ajsecurities.com.hk'],
  ['Bank of America Merrill Lynch', 'Eddie Leung', 'eddie.leung@baml.com'],
  ['Bank of China International', 'Michael Meng', 'Michael.meng@bocigroup.com'],
  ['Benchmark Company LLC', 'Fawne Jiang', 'fjiang@benchmarkcompany.com'],
  ['Bernstein Research', 'Robin Zhu', 'robin.zhu@bernstein.com'],
  ['BOCOM International Holdings', 'Connie Gu', 'connie.gu@bocomgroup.com'],
  ['CCB International (Holdings) Limited', 'Ronnie Ho', 'ronnieho@ccbintl.com'],
  ['China International Capital Corporation', 'Yang Bai', 'yang3.bai@cicc.com.cn'],
  ['China Merchants Securities (Hong Kong)', 'Tommy Wong', 'tommywong@cmschina.com.hk'],
  ['China Renaissance Securities (US)', 'Ella Ji', 'ellaji@chinarenaissance.com'],
  ['China Securities Co., Ltd', 'Xiaolei Sun', 'sunxiaolei@csc.com.cn'],
  ['Citic Securities', 'Ya Jiang', 'jiangya@citics.com'],
  ['Citigroup Global Markets Asia Limited', 'Alicia Yap', 'alicia.yap@investmentresearch.citi.com'],
  ['CLSA Limited', 'Elinor Leung', 'elinor.leung@clsa.com'],
  ['CMB International Capital Corp Ltd', 'Saiyi He', 'hesaiyi@cmbi.com.hk'],
  ['Credit Suisse (Hong Kong) Limited', 'Kenneth Fong', 'kenneth.kc.fong@credit-suisse.com'],
  ['Daiwa Capital Markets Hong Kong Limited', 'John Choi', 'john.choi@hk.daiwacm.com'],
  ['First Shanghai Securities Ltd.', 'Jinglin Li', 'Jinglin.li@firstshanghai.com.hk'],
  ['GF Securities', 'Shi Kuang', 'kuangshi@gf.com.cn'],
  ['Goldman Sachs (Asia) LLC', 'Ronald Keung', 'ronald.keung@gs.com'],
  ['Guosen Securities', 'Xueheng Wang', 'wangxueh@guosen.com.cn'],
  ['Guosheng Securities Co., Ltd', 'Yueying Du', 'duyueying@gszq.com'],
  ['Guotai Junan Securities', 'Liu Yuenan', 'liuyuenan@gtjas.com'],
  ['Guotai Junan Securities', 'Zheng Zhao', 'zhaozheng020321@gtjas.com'],
  ['Haitong International Securities Group Limited', 'Natalie Wu', 'Natalie.wu@htisec.com'],
  ['Haitong Securities', 'Liting Wang', 'wanglt@htsec.com'],
  ['HSBC', 'Charlene Liu', 'charlene.r.liu@hsbc.com.sg'],
  ['Huatai Financial Holdings (Hong Kong) Limited', 'Jie Hou', 'houjie017864@htsc.com'],
  ['ICBC International Research Limited', 'Zeping Zhao', 'Zeping.zhao@icbci.icbc.com.cn'],
  ['Industrial Securities', 'Jiajun Hong', 'hongjiajun@xyzq.com.cn'],
  ['J.P. Morgan Securities (Asia Pacific) Limited', 'Alex Yao', 'alex.yao@jpmorgan.com'],
  ['Jefferies Hong Kong', 'Thomas Chong', 'thomas.chong@jefferies.com'],
  ['Macquarie Capital', 'Ellie Jiang', 'Ellie.jiang@macquarie.com'],
  ['Morgan Stanley', 'Gary Yu', 'Gary.Yu@morganstanley.com'],
  ['New Street Research', 'Jin K. Yoon', 'jin.yoon@newstreetresearch.com.hk'],
  ['Nomura International (Hong Kong) limited', 'Jialong Shi', 'Jialong.shi@nomura.com'],
  ['SWS Research Co.,LTD.', 'Lingyi Zhao', 'zhaoly2@swsresearch.com'],
  ['T.H. Capital Research', 'Tian X. Hou', 'thou@thdatacapital.com'],
  ['UBS Securities Asia Limited', 'Jerry Liu', 'jerry.liu@ubs.com'],
  ['UOB Kay Hian', 'Julia Pan', 'juliapan@uobkayhian.com'],
].map((analyst) => {
  return {
    coop: analyst[0],
    name: analyst[1],
    email: analyst[2],
  };
});

export default AnalystData;
